import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import {  Unsubscribable } from 'rxjs';
import { Utility } from '../../../_service/utility';
import { environment } from '../../../../environments/environment';
import { SocketFacade } from 'app/_modules/socket/socket.facade';
import { NavigationEnd, Router } from '@angular/router';
import { UserService } from '../../../_service/user/user.service';
import { NotifyMessageCount } from '../../../_model/user/user.model';

@Component({
  selector: 'app-dropdown-notifications',
  templateUrl: './dropdown-notifications.component.html',
  styleUrls: ['./dropdown-notifications.component.scss']
})

export class DropdownNotificationsComponent implements OnInit, OnDestroy {
  ngOnDestroy(): void {
    this.subscriptions.forEach(p => p.unsubscribe());
  }
  isSubscriptEnabled = environment.cinema == 1;
  user;
  activeTab = 'favorites';
  @Input()
  data: any;
  concatsHasUnreadMessage = []

  
  constructor(
    private _userService:UserService,
    private socketFacade: SocketFacade,
    private _router: Router,
    private _utility:Utility

  ) {

  }

  // readState() {

  //   if (this.user && (this.user.notifications.favorites === 0) && this.user.notifications.messages) {
  //     this.activeTab = 'messages';
  //   }
  // }
 // private unsb = null;

  public subscriptions: Array<Unsubscribable> = [];

  ngOnInit() {

    // this.notifications.favorites =0;
    // this.notifications.messages =0;
    // this.notifications.subscriptions =0;

    this.user = this._userService.user;
    this.subscriptions.push(
    
      this._userService.userState$.subscribe(user=>{
        this.user = user;
      }),
      this.socketFacade.concatsHasUnreadMessage$.subscribe(r => this.concatsHasUnreadMessage = r),
      // this._router.events.subscribe(
      //   (event) => {
      //     if (event instanceof NavigationEnd) {
      //       const url = event.urlAfterRedirects.split('?')[0];
      //       if (url === '/user/messages/chat') {
      //         this.concatsHasUnreadMessage = [];
      //       }
      //     }
      //   }
      // ),
      this._userService.notificationState$.subscribe(p=>{
        this.notifications = p;
       // console.log(this.notifications)
      }),
      this._utility.GetOrCreateSubscript("ClearNotify.fav").subscribe(p => {
        this.notifications.favorites = 0;
        // this.user.notifications.favorites = 0;
      }),
      this._utility.GetOrCreateSubscript("ClearNotify.follow").subscribe(p => {
        this.notifications.follows = 0;
      }),
    );
    // console.log(this.data);
  }

  notifications:NotifyMessageCount  = new NotifyMessageCount();

}
